type DerivedKeyAuthorizationData = {
  ExpirationBlock?: number;
  IsValid?: boolean;
  TransactionSpendingLimit?: {
    GlobalDESOLimit?: number;
    IsUnlimited?: boolean;
  } | null;
};

export const DERIVED_KEY_BLOCK_HEIGHT_OFFSET = 100;

type NeedsDerivedKeyAuthorizationRefreshArgs = {
  blockHeight: number;
  blockHeightOffset?: number;
  derivedKey?: DerivedKeyAuthorizationData | null;
  spendAmountDesoNanos?: number;
};

export const needsDerivedKeyAuthorizationRefresh = ({
  blockHeight,
  blockHeightOffset = DERIVED_KEY_BLOCK_HEIGHT_OFFSET,
  derivedKey,
  spendAmountDesoNanos = 0,
}: NeedsDerivedKeyAuthorizationRefreshArgs) => {
  const isValid = derivedKey?.IsValid;
  const globalDesoLimitNanos =
    derivedKey?.TransactionSpendingLimit?.GlobalDESOLimit ?? 0;
  const isUnlimited = derivedKey?.TransactionSpendingLimit?.IsUnlimited;
  const expirationBlock = derivedKey?.ExpirationBlock ?? 0;

  return (
    !isValid ||
    (spendAmountDesoNanos > globalDesoLimitNanos && !isUnlimited) ||
    blockHeight + blockHeightOffset >= expirationBlock
  );
};
